import { defineComponent as _defineComponent } from 'vue'
import ConfirmDeleteModal from "@/components/ui/modals/ConfirmDeleteModal.vue";
  import InputSearch from "@/components/ui/input/InputSearch.vue";
  import { computed, onMounted, ref, watch } from "vue";
  import router from "@/router";
  import store from "@/store";
  import { getStageStatusClass } from "@/helpers/status";
  import { debounce } from "@/helpers/debounce";
  import { StageInterface } from "@/types/StageInterface";
  import { useToast } from "vue-toastification";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'AdminEstateStages',
  props: {
    estateId: { type: String, required: false },
    landownerId: { type: String, required: false },
    isConciergeView: { type: Boolean, default: false },
  },
  emits: ["toLots"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const props = __props;
  const emit = __emit;
  const toast = useToast();
  const userId = computed(
    () => props.landownerId || router.currentRoute.value.params.userId
  );
  const estateId = computed(
    () => props.estateId || router.currentRoute.value.params.estateId
  );
  const stages = ref<StageInterface[]>([]);
  const searchQuery = ref("");
  const debounceSearch = debounce(getStages);
  const showConfirmDeleteModal = ref(false);
  const itemForDelete = ref({ id: "", title: "" });

  watch(
    estateId,
    (newEstateId) => {
      if (newEstateId) {
        getStages();
      }
    },
    { immediate: true }
  );

  watch(
    () => searchQuery.value,
    () => {
      debounceSearch();
    }
  );

  onMounted(() => {
    getStages();
  });

  function getStages() {
    store
      .dispatch("stage/getStages", {
        title: searchQuery.value,
        estateId: estateId.value,
      })
      .then((res) => {
        stages.value = res.data;
      });
  }
  function toStage(id: string) {
    if (!props.isConciergeView) {
      router.push({
        name: "AdminStage",
        params: { userId: userId.value, estateId: estateId.value, stageId: id },
      });
    } else {
      emit("toLots", id);
    }
  }
  function toCreateStage() {
    router.push({
      name: "AdminStageCreate",
      params: { userId: userId.value, estateId: estateId.value },
    });
  }
  function deleteStage(id: string) {
    store
      .dispatch("stage/deleteStage", id)
      .then(() => {
        getStages();
        toast.success("The stage was successfully deleted");
      })
      .catch((err) => {
        if (err.response.data?.message) {
          toast.error(err.response.data.message);
        } else {
          toast.error("Something went wrong");
        }
      });
  }
  function setItemForDelete(stage: StageInterface) {
    itemForDelete.value = { id: stage._id, title: stage.title };
    showConfirmDeleteModal.value = true;
  }

const __returned__ = { props, emit, toast, userId, estateId, stages, searchQuery, debounceSearch, showConfirmDeleteModal, itemForDelete, getStages, toStage, toCreateStage, deleteStage, setItemForDelete, ConfirmDeleteModal, InputSearch, computed, onMounted, ref, watch, get router() { return router }, get store() { return store }, get getStageStatusClass() { return getStageStatusClass }, get debounce() { return debounce }, get StageInterface() { return StageInterface }, get useToast() { return useToast } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})